import React, { useState } from 'react';
import { Button, Form, Grid, Header, Segment } from 'semantic-ui-react';

const LoginForm = (props) => {
	const [login, setLogin] = useState('');
	const [password, setPassword] = useState('');
	const auth = () => {
		props.callback({ login, password });
	}

	return (<Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
		<Grid.Column style={{ maxWidth: 450 }}>
			<Header as='h2' color='teal' textAlign='center'>Авторизация</Header>
			<Form size='large'>
				<Segment stacked>
					<Form.Input
						fluid
						icon='user'
						iconPosition='left'
						placeholder='Логин'
						type='text'
						value={login}
						onChange={(e, {value}) => setLogin(value)}
					/>
					<Form.Input
						fluid
						icon='lock'
						iconPosition='left'
						placeholder='Пароль'
						type='password'
						value={password}
						onChange={(e, {value}) => setPassword(value)}
					/>
					<Button onClick={auth} color='teal' fluid size='large'>
						Войти
					</Button>
				</Segment>
			</Form>
		</Grid.Column>
	</Grid>)
}

export default LoginForm;
